/*jshint browserify: true */
'use strict';

require('./PolyFills/childnode-remove.js');

/**
 * @name ContextMenu
 * @description
 * Container for a context-menu.
 * 
 * @param {Node} parentHtmlElement - The parent node (most likely a HtmlElement) that will "contain" the context menu.
 *   HTML for the context-menu will be appended to the end of this node.
 */
var ContextMenu = (function ContextMenuClosure() {
    function ContextMenu(parentHtmlElement) {
        if (!(parentHtmlElement instanceof Node)) {
            throw 'Cannot create context menu, provided parent was of type ' + typeof parentHtmlElement + ', but expected Node';
        }

        this._parentNode = parentHtmlElement;
        this._menuElement = null;

        window.addEventListener('mousedown', function (event) {
            if (this._menuElement !== null) {
                // Close context menu if target is not inside the context menu element
                if (!this._menuElement.contains(event.target)) {
                    this.close();
                }
            }
        }.bind(this));
    }

    var minimumWidthSpace = 200;
    var minimumHeightSpace = 200;

    ContextMenu.prototype = {

        /**
         * Close/hide the context-menu.
         */
        close: function () {
            if (this._menuElement !== null) {
                this._menuElement.remove();
                this._menuElement = null;
            }
        },

        /**
         * Show the context-menu.
         * The position specified by parameters is nominally the top-left point of the context-menu.
         * It may be repositioned if that position is invalid, e.g. buttom-right of browser viewport.
         *
         * @param {number} positionX - Position to show the context-menu at, x co-ordinate in browser viewport space.
         * @param {number} positionY - Position to show the context-menu at, y co-ordinate in browser viewport space.
         * @param {string} template - HTML for the context menu.
         */
        show: function (positionX, positionY, template) {
            this.close();

            this._menuElement = document.createElement('div');
            this._menuElement.innerHTML = template;
            this._menuElement.id = 'pdf-context-menu';
            this._menuElement.style.position = 'fixed';
            this._menuElement.style.background = 'white';
            this._menuElement.style.border = 'solid 1px rgb(128, 128, 128)';
            //this._menuElement.style.padding = '4px';
            this._menuElement.style['box-shadow'] = '0px 3px 5px 0px rgba(0, 0, 0, 0.2)';
            this._parentNode.appendChild(this._menuElement);

            if (positionX + this._menuElement.clientWidth > window.innerWidth) {
                positionX -= this._menuElement.clientWidth;
            }

            if (positionY + this._menuElement.clientHeight > window.innerHeight) {
                positionY -= this._menuElement.clientHeight;
            }

            this._menuElement.style.left = positionX + 'px';
            this._menuElement.style.top = positionY + 'px';

            return this._menuElement;
        }
    };

    return ContextMenu;
})();

module.exports = ContextMenu;